import makeStyles from '@mui/styles/makeStyles';
import { On3IconSoftballLogo } from '@on3/icons';
import { On3Header } from '@on3/ui-lib/components/Svg/On3Header';
import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import clsx from 'clsx';
import { Auth } from 'components/Header/Auth/Auth';
import { SiteLogo } from 'components/Image/SiteLogo';
import { Text } from 'components/UI/Typography/Text';
import Link from 'next/link';
import { useMemo } from 'react';

import styles from './SubscribeHeader.module.scss';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: theme.appHeader.backgroundColor,
  },
}));

export const SubscribeHeader = () => {
  const { currentSite } = useSite();
  const classes = useStyles();
  const isSoftballAmerica = currentSite?.key === 401;
  const isTeam = currentSite?.isTeam && !isSoftballAmerica;
  const isChannel = currentSite?.isChannel && !isSoftballAmerica;

  const channelStyle = useMemo(() => {
    if (isChannel) {
      return { backgroundColor: currentSite?.primaryColor ?? '#3B4147' };
    }
  }, [currentSite?.primaryColor, isChannel]);

  return (
    <header
      className={clsx(classes.header, styles.header)}
      style={channelStyle}
    >
      {isTeam && (
        <Link className={styles.logo} href={`${currentSite?.url}/`}>
          <SiteLogo className={styles.teamlogo} width={50} />
        </Link>
      )}
      {isChannel && (
        <Link className={styles.logo} href={`${currentSite?.url}/`}>
          <On3Header />
          <Text className={styles.teamName}>{currentSite.name}</Text>
        </Link>
      )}
      {isSoftballAmerica && (
        <Link
          className={clsx(styles.logo)}
          href="/softball/"
          title="Softball America Home"
        >
          <On3IconSoftballLogo height="51" width="112" />
        </Link>
      )}
      {!isTeam && !isChannel && !isSoftballAmerica && (
        <Link className={styles.logo} href="/">
          <On3Header />
        </Link>
      )}
      <div className={styles.authSection}>
        <Auth isSubscribe={true} />
      </div>
    </header>
  );
};
